import * as React from 'react'
import { DetailedResource } from '../../../common/resource/model'
import { builtInDetailUrl } from '../../Sidebar/Urls'
import { getMuleVersion } from './utils'

import {
  DeprecatedRuntimeImage,
  shouldShowDeprecatedRuntimeImage
} from './Notification/DeprecatedRuntimeImage/DeprecatedRuntimeImage'

export type ValueProps = {
  detailedResource?: DetailedResource
  orgDomain: string
  organizationId: string
  environmentId: string
}

export type Props = ValueProps

const NotificationSwitcher = (props: Props) => {
  const {detailedResource, orgDomain, environmentId, organizationId} = props
  if (!detailedResource) return null

  const muleVersion = getMuleVersion(detailedResource)

  if (muleVersion && shouldShowDeprecatedRuntimeImage(muleVersion)) {
    const upgradeUrl = builtInDetailUrl(detailedResource, orgDomain, organizationId, environmentId)
    return <DeprecatedRuntimeImage deprecatedVersion={muleVersion} upgradeUrl={upgradeUrl}/>
  }

  return null
}

export default NotificationSwitcher
